<template>
  <div class="full-page-width relative locations">
    <div class="row">
      <div class="col-xs-4 sticky-100">
        <div class="flex-center m-b-40 h-40">
          <div class="flex-center">
            <Btn
              v-if="nameAndBackOption"
              @click.native="routeIt"
              class="light bordered empty d-inline-block m-r-15 fix-40"
              :icon="{
                name: 'arrowLeftBig',
                size: '20',
              }" />
            <p class="user-name">{{ $t('Profile') }}</p>
          </div>
        </div>
        <UserCard @openPopupEdit="openEditPopup" :isEditable="isEditableProfile" />
      </div>
      <div class="col-xs-8">
        <h2 class="page-title heighted">{{ $t('Wall') }}</h2>
        <div
          v-for="(item, index) in get_news.items" :key="`wallItem-${index}`"
          class="card m-b-20 wall-item no-pad">
          <div class="news-header flex m-b-20">
            <div class="post-image m-r-20">
              <div class="status-indicator"></div>
              <span class="initials">
                {{ `${item.first_name.charAt(0)}${item.last_name.charAt(0)}` }}
              </span>
              <img :src="item.image" v-if="item.image !== null"/>
            </div>
            <div class="author-title">
              <p>{{ `${item.first_name} ${item.last_name}` }}</p>
              <span>{{ formatDate(item.created_at, 'shipment') }}</span>
            </div>
          </div>
          <div class="news-body">
            <p class="news-text" v-html="sanitizeHtml(item.note)"></p>
          </div>
        </div>
      </div>
    </div>
    <Popup
      v-if="openPopup"
      :popupSmall=true
      :isPopupSubmitDisabled="isPopupSubmitDisabled"
      :showConfirmButton="!deleteUser"
      :showDeleteButton="deleteUser"
      @cancel="togglePopup"
      @deleteAction="deleteUserAction"
      @confirm="submitForm">
      <template v-slot:header>
        <h2>{{ $t('Edit profile') }}</h2>
      </template>
      <div>
        <div class="row" v-if="get_is_admin">
          <div class="col-xs-12">
            <div class="flex-center toggle-title">
              <div class="input-select">
                <label>{{ $t('activate_user')}}</label>
                <span>{{ $t('enable_user_to_login') }}</span>
              </div>
              <div>
                <Toggle id="deactivateUser" v-model="form.is_active" />
              </div>
            </div>
          </div>
        </div>
        <div class="separator medium" v-if="get_is_admin"></div>
        <div class="row">
          <div class="col-xs-12 m-b-20" v-if="get_user.is_super_admin">
            <InputSelect
              :multiSelect=true
              :label="$t('Accessible accounts')"
              :preselected="form.accessible_subaccounts"
              @change="selectSubaccounts"
              :options="subacountsList"/>
          </div>
          <div class="col-xs-12 m-b-20" v-if="(get_user.is_admin && !get_stored_user.is_super_admin) || get_user.is_system_user">
            <InputSelect
               class="m-b-20"
               :multiSelect=true
               :preselected="form.accessible_for_subaccounts"
               :label="$t('accessible_for_accounts')"
               @change="selectAccessibleForSubaccounts"
               :options="getAllowedSubaccounts" />
          </div>
          <InputText
            :disabled=true
            class="col-xs-6 m-b-20"
            label="E-mail"
            v-model="form.email"
            :rules="{required: true, email: true}" />
          <InputText
            class="col-xs-6 m-b-20"
            :label="$t('Title')"
            v-model="form.function" />
          <InputText
            class="col-xs-6 m-b-20"
            :label="$t('name')"
            v-model="form.first_name"
            :rules="{required: true}" />
          <InputText
            class="col-xs-6 m-b-20"
            :label="$t('Surname')"
            v-model="form.last_name"
            :rules="{required: true}" />
          <PhoneSelect class="col-xs-12" key="userPhone" v-model="form.phone" />
        </div>
        <div class="separator medium"></div>
        <div class="row">
          <div class="col-xs-12">
            <div class="flex-center toggle-title">
              <div>
                <p>{{ $t('Reset password') }}</p>
                <span>{{ $t('This will reset password') }}</span>
              </div>
              <div>
                <Btn
                  class="brand"
                  :icon="{name: 'restore',size: '20'}"
                  :btnText="$t('Reset')"
                  @btnClick="resetPassword" />
              </div>
            </div>
          </div>
        </div>
        <div class="separator medium" v-if="get_is_admin && !get_stored_user.is_admin"></div>
        <div class="row" v-if="get_is_admin && !get_stored_user.is_admin">
          <div class="col-xs-12">
            <div class="flex-center toggle-title">
              <div>
                <p>{{ $t('delete_user') }}</p>
                <span>{{ $t('User will be deleted') }}</span>
              </div>
              <div>
                <Toggle color="red" id="deleteUser" v-model="deleteUser" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
/* eslint-disable */
import {mapGetters} from 'vuex';
import UserCard from '@/components/global/userCard';
import Btn from '@/components/elements/buttons';
import Popup from '@/components/global/popup';
import InputText from '@/components/elements/inputs/text.vue';;
import InputSelect from '@/components/elements/inputs/select.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import date from '@/mixins/date';
import formValidator from '@/mixins/formValidator';
import sanitize from '@/mixins/sanitize';

export default {
  name: 'Wall',
  components: {
    UserCard, Btn, Popup, InputText, InputSelect, Toggle, PhoneSelect,
  },
  mixins: [date, formValidator, sanitize],
  data() {
    return {
      openPopup: false,
      deactivateUser: false,
      deleteUser: false,
      form: {
        is_admin: '',
        active_subaccount_id: '',
        is_active: '',
        language: '',
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        function: '',
        return_waybill_action_type: '',
        label_printer_id: '',
        label_format: '',
        goods_type_id: '',
        package_id: '',
        weight_type: '',
        dimension_type: '',
        should_show_freight_prices: '',
        phone: {
          number: '',
          country: '',
        },
        accessible_subaccounts: [],
        accessible_for_subaccounts: []
      },
      isVisibleBack: this.$route.params.id,
    };
  },
  computed: {
    ...mapGetters([
      'get_is_admin',
      'get_user',
      'get_wall_news',
      'get_stored_user',
      'get_subaccounts',
    ]),
    isPopupSubmitDisabled() {
      const formWithValidators = [
        {
          formFeild:'email',
          value: this.form.email,
          validators:{required: true, email: true}
        },
        {
          formFeild:'first_name',
          value: this.form.first_name,
          validators:{required: true}
        },
        {
          formFeild:'last_name',
          value: this.form.last_name,
          validators:{required: true}
        },
      ]
      return this.validateInput(formWithValidators);
    },
    getAllowedSubaccounts() {
      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({text: acc.name, value: String(acc.id),}));
    },
    subacountsList() {
      return this.get_subaccounts.map((acc) => ({text: acc.name, value: String(acc.id)}));
    },
    nameAndBackOption() {
      return this.$route.params.id != undefined ? true : false;
    },
    isEditableProfile() {
      //If user is super admin only owner or system user can change user data
      if ((this.get_user.id != this.get_stored_user.id) && this.get_stored_user.is_super_admin && !this.get_user.is_system_user) {
        return false;
      }

      if( this.get_is_admin || (this.$route.params.id === undefined)) {
        return true;
      } else if( this.$route.params.id == this.get_user.id ) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.$store.dispatch('GET_WALL_NEWS');
  },
  methods: {
    selectAccessibleForSubaccounts(val) {
        this.form.accessible_for_subaccounts = val;
    },
    selectSubaccounts(val) {
        this.form.accessible_subaccounts = val;
    },
    routeIt() {
      this.$router.push('/settings/platform/team');
    },
    changeLanguage(language) {
      this.$store.dispatch('STORE_LANGUAGE', language);
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
    },
    submitForm() {
      let subaccountId = '';
      if(this.form.accessible_subaccounts.indexOf(String(this.form.active_subaccount_id)) > -1){
        subaccountId = String(this.form.active_subaccount_id);
      } else {
        subaccountId = String(this.form.accessible_subaccounts[0]);
        if(this.$route.name == 'profile-wall'){
          this.$store.dispatch(
            'STORE_ACTIVE_SUBACCOUNT',
            this.get_subaccounts.filter((subaccount) => subaccount.id == subaccountId)[0]
          );
        }
      }

      this.$store.dispatch(`EDIT_USER`, {
        form: { ...this.form, phone: this.form.phone.number, active_subaccount_id: subaccountId},
        id: this.get_stored_user.id,
      }).then(() => {
        this.openPopup = false;
        this.$store.dispatch('GET_USER', {id: this.get_stored_user.id});
        this.$store.dispatch('GET_PROFILE').then((profileRes) => {
          this.$store.dispatch('STORE_USER', profileRes);
        });
      });
    },
    openEditPopup() {
      this.togglePopup()
      this.form = {
        is_admin: this.get_stored_user.is_admin,
        active_subaccount_id: this.get_stored_user.active_subaccount_id,
        is_active: this.get_stored_user.is_active,
        language: this.get_stored_user.language,
        email: this.get_stored_user.email,
        first_name: this.get_stored_user.first_name,
        last_name: this.get_stored_user.last_name,
        function: this.get_stored_user.function,
        return_waybill_action_type: this.get_stored_user.return_waybill_action_type,
        label_printer_id: this.get_stored_user.label_printer_id,
        label_format: this.get_stored_user.label_format,
        goods_type_id: this.get_stored_user.goods_type_id,
        package_id: this.get_stored_user.package_id,
        weight_type: this.get_stored_user.weight_type,
        dimension_type: this.get_stored_user.dimension_type,
        should_show_freight_prices: this.get_stored_user.should_show_freight_prices,
        phone: {
          number: this.get_stored_user.phone,
          country: '',
        },
        accessible_subaccounts: this.get_stored_user.accessible_subaccounts_array,
        accessible_for_subaccounts: this.get_stored_user.accessible_for_subaccounts
      }
    },
    resetPassword() {
      this.$store.dispatch('FORGOT_PASSWORD', {email: this.get_stored_user.email}).then(() => {
        this.openPopup = false;
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: this.$t('reset_password_notification_msg'),
          type: 'success-window',
        });
      });
    },
    deleteUserAction() {
      this.$store.dispatch('DELETE_USER', this.get_stored_user.id).then(() => {
        this.openPopup = false;
        this.$router.push('/settings/platform/team')
      });
    },
  },
};
</script>
